export const COUPON_GROUPS_VIEW_PATH = "/coupon-groups";
export const COUPON_GROUPS_DETAIL_VIEW_PATH = "/coupon-groups/:couponGroupUuid";
export const COUPON_GROUPS_COUPONS_VIEW_PATH =
  "/coupon-groups/:couponGroupUuid/coupons";
